import React, { useState } from "react";

import { Transition } from "@headlessui/react";
import { useLocation } from "react-router-dom";

import Button from "../elements/Button";
import BrandIcon from "./BrandIcon";

const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/catalog", label: "Catalog" },
  { href: "/product", label: "Products" },
  { href: "/about", label: "About Us" },
];

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  return (
    <header className="sticky top-0 z-40 border-b border-slate-100 bg-white/95 backdrop-blur-sm">
      <div className="container mx-auto flex items-center justify-between px-4 py-3 lg:px-10 lg:py-4">
        <BrandIcon />

        <button
          type="button"
          className="rounded-lg p-2 text-maroon-800 hover:bg-maroon-50 lg:hidden"
          aria-label="Toggle menu"
          aria-expanded={isCollapse}
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <svg
            className="h-7 w-7"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              className={isCollapse ? "hidden" : "block"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
            <path
              className={!isCollapse ? "hidden" : "block"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((link) => (
            <Button
              key={link.href}
              type="link"
              href={link.href}
              className={`rounded-lg px-4 py-2 text-[15px] font-medium tracking-wide text-slate-600 no-underline transition-colors hover:bg-maroon-50 hover:text-maroon-700 ${
                path === link.href ? "text-maroon-700" : ""
              }`}
            >
              {link.label}
            </Button>
          ))}
          <Button
            type="link"
            href="/contact-us"
            className="ml-3 rounded-full bg-maroon-700 px-6 py-2.5 text-[15px] font-semibold text-white shadow-sm transition-colors hover:bg-maroon-800"
          >
            Contact Us
          </Button>
        </nav>
      </div>

      <Transition
        show={isCollapse}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <nav className="absolute z-50 flex w-full flex-col border-b border-slate-100 bg-white shadow-lg lg:hidden">
          {NAV_LINKS.map((link) => (
            <Button
              key={link.href}
              type="link"
              href={link.href}
              onClick={() => setIsCollapse(false)}
              className={`px-6 py-3 text-base font-medium text-slate-600 no-underline hover:bg-maroon-50 hover:text-maroon-700 ${
                path === link.href ? "text-maroon-700" : ""
              }`}
            >
              {link.label}
            </Button>
          ))}
          <div className="p-4">
            <Button
              type="link"
              href="/contact-us"
              onClick={() => setIsCollapse(false)}
              className="flex justify-center rounded-full bg-maroon-700 px-6 py-3 text-base font-semibold text-white"
            >
              Contact Us
            </Button>
          </div>
        </nav>
      </Transition>
    </header>
  );
}
